import { getArgoNftAddress } from 'utils/addressHelpers'
import { CHAIN_TYPE } from 'utils/calls'

export interface EcoFarmConfig {
  name: string
  nftName: string
  icon: string
  iconWidth: number
  maxStakedNum: number
  boostFactorPerNFT: number
  collectionAddress: string
  chain: CHAIN_TYPE
}

export const ecoFarm: Record<string, EcoFarmConfig> = {
  argo: {
    name: 'Argo',
    nftName: 'Argonauts',
    icon: '/images/igo/logo/0x2a59804792EDB39889aA144417c6437a48Fdf9fa.png',
    iconWidth: 23,
    maxStakedNum: 5,
    boostFactorPerNFT: 0.1,
    collectionAddress: getArgoNftAddress(),
    chain: CHAIN_TYPE.CRONOS,
  },
}
